import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';

import { ObservabilityService } from '@core/services/observability.service';

import { SnackBarService } from '@shared/service';
import { resolveErrorMessage } from '@shared/utils';

import { environment } from '@environments';

const SKIP_STATUSES = new Set([401, 403]);

export function ErrorHttpInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const snackBar = inject(SnackBarService);
  const observability = inject(ObservabilityService);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && !SKIP_STATUSES.has(err.status)) {
        const code = typeof err.error?.code === 'string' ? err.error.code : undefined;
        const message = resolveErrorMessage(err.status, code);

        // Record error in trace
        observability.recordException(new Error(`HTTP ${err.status}: ${err.message}`), {
          'http.status_code': err.status,
          'http.url': err.url || 'unknown',
          'error.code': code || 'unknown',
          'error.message': err.message,
        });

        if (environment.dev && err.error?.detail) {
          console.error(`[HTTP ${err.status}] ${err.error?.detail}`);
        }

        snackBar.error(message);
      }

      return throwError(() => err);
    }),
  );
}
